/*
  ЦИФРОВОЙ ДИАК ЗФ — MEMOS API CLIENT
  Тонкие обёртки над /api/memos. Изолировано от ProjectContext/realtime.
*/

import { apiJson } from "@/lib/api";

export type MemoType = "planning" | "demo" | "brainstorm" | "other";

export interface MemoSections {
  summary: string;
  organization: string;
  directions: string;
  decisions: string;
  actionItems: string;
  risks: string;
  milestones: string;
}

export interface MemoListItem {
  id: string;
  type: MemoType;
  title: string;
  meetingDate: string;
  participants: string;
  createdAt: string;
  updatedAt: string;
}

export interface Memo extends MemoListItem {
  transcript: string;
  sections: MemoSections;
  createdBy?: number;
}

export const EMPTY_SECTIONS: MemoSections = {
  summary: "",
  organization: "",
  directions: "",
  decisions: "",
  actionItems: "",
  risks: "",
  milestones: "",
};

export async function listMemos(): Promise<MemoListItem[]> {
  const res = await apiJson<{ ok: true; memos: MemoListItem[] }>("/api/memos");
  return res.memos;
}

export async function getMemo(id: string): Promise<Memo> {
  const res = await apiJson<{ ok: true; memo: Memo }>(`/api/memos/${encodeURIComponent(id)}`);
  return res.memo;
}

export async function createMemo(input: {
  type: MemoType;
  title: string;
  meetingDate: string;
  participants?: string;
  transcript?: string;
  sections?: Partial<MemoSections>;
}): Promise<Memo> {
  const res = await apiJson<{ ok: true; memo: Memo }>("/api/memos", {
    method: "POST",
    body: JSON.stringify(input),
  });
  return res.memo;
}

export async function updateMemo(
  id: string,
  patch: Partial<{
    type: MemoType;
    title: string;
    meetingDate: string;
    participants: string;
    transcript: string;
    sections: Partial<MemoSections>;
  }>,
): Promise<Memo> {
  const res = await apiJson<{ ok: true; memo: Memo }>(`/api/memos/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
  return res.memo;
}

export async function deleteMemo(id: string): Promise<void> {
  await apiJson(`/api/memos/${encodeURIComponent(id)}`, { method: "DELETE" });
}

export async function draftMemoFromTranscript(
  type: MemoType,
  transcript: string,
  meetingDate?: string,
): Promise<{ sections: MemoSections; model: string }> {
  const res = await apiJson<{ ok: true; sections: MemoSections; model: string }>(
    "/api/memos/draft",
    { method: "POST", body: JSON.stringify({ type, transcript, meetingDate }) },
  );
  return { sections: res.sections, model: res.model };
}
